import React from "react";
import "./TermCondition.css";

const TermsAndConditions = () => {
  return (
    <section className="terms-section">
      <div className="terms-container">
        <h1>Terms & Conditions</h1>
        <p className="note">
          This document is an electronic record in terms of the Information Technology Act, 2000 and rules made thereunder. It does not require any physical or digital signature.
        </p>
        <p>
          This document is published in accordance with Rule 3(1) of the Information Technology (Intermediaries Guidelines) Rules, 2011, which requires publishing rules, regulations, privacy policy, and terms of use for accessing or using the domain <a href="https://kaamvala.com/" target="_blank" rel="noopener noreferrer">kaamvala.com</a> including its mobile site and mobile application (hereinafter referred to as the "Platform").
        </p>
        <p>
          The Platform is owned by <strong>KAAMVALA JOBS and SERVICES</strong>, a company registered under the Companies Act, 1956, having its office at 3RD FLOOR, C1-307, TOWER C1, PRATEEK GRAND CITY, SIDDHARTH VIHAR, Ghaziabad, India (referred to as "Platform Owner", "we", "us", or "our").
        </p>

        <ol className="terms-list">
          <li>
            By accessing, browsing, or using the Platform, you agree to be bound by these Terms of Use. Please read them carefully.
          </li>
          <li>
            You agree to provide true, accurate, and complete information during registration and are responsible for all activities under your account.
          </li>
          <li>
            We do not guarantee the accuracy, performance, or completeness of any content. Use the Platform and Services at your own risk.
          </li>
          <li>
            All content on the Platform is proprietary. You may not claim any rights or reuse it without permission.
          </li>
          <li>
            Unauthorized use of the Platform may result in legal action under applicable laws.
          </li>
          <li>
            You agree to pay applicable charges for availing the Services.
          </li>
          <li>
            You shall not use the Platform for illegal or unauthorized purposes.
          </li>
          <li>
            Third-party links may be provided for convenience. Your use of such links will be governed by those third parties’ terms and policies.
          </li>
          <li>
            Initiating a transaction on the Platform constitutes a binding contract with the Platform Owner.
          </li>
          <li>
            You agree to indemnify the Platform Owner and its affiliates against claims arising out of your breach of the Terms or violation of laws or third-party rights.
          </li>
          <li>
            We are not liable for delays or failures caused by force majeure events.
          </li>
          <li>
            These Terms are governed by the laws of India.
          </li>
          <li>
            All disputes are subject to the exclusive jurisdiction of courts in Ghaziabad, Uttar Pradesh.
          </li>
          <li>
            For any concerns, please contact us via the communication details provided on the Platform.
          </li>
        </ol>
      </div>
    </section>
  );
};

export default TermsAndConditions;
